var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataPage == '')?_c('div',{staticClass:"nullPic"},[_c('img',{attrs:{"src":require("@/assets/暂无数据.png"),"alt":""}}),_vm._v(" 您还没有发起过风险检测哦～ ")]):_vm._l((_vm.dataPage),function(item,index){return _c('div',{key:index,staticClass:"detectionCard",class:index == 0 ? 'topStyle' : ''},[_c('ATestLog',{attrs:{"item":item}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }